import { getNavigationTrail, getPageLoadType } from '@utils/navigationTrail';

export const getNotFoundReport = (pathname: string, isPwa: boolean) => ({
  path: pathname,
  trail: getNavigationTrail(),
  history_length: window.history.length,
  page_load_type: getPageLoadType(),
  is_pwa: isPwa,
});

export const formatNotFoundReport = ({ trail, ...rest }: ReturnType<typeof getNotFoundReport>) =>
  [
    Object.entries(rest)
      .map(([key, value]) => `${key}: ${String(value)}`)
      .join(' | '),
    ...trail.map(
      ({ event, path, params, secondsAgo }) =>
        `-${secondsAgo}s ${event}${path ? ` ${path}` : ''}${params?.length ? ` ?${params.join(',')}` : ''}`,
    ),
  ].join('\n');
